module.exports = __webpack_public_path__ + "static/media/swipe-tablet.c0f24a9c.gif";